import * as React from "react";
const SvgFiRrDigging = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-digging_svg__a)">
      <path
        fill="#062147"
        d="m23.751 20.08-2.509-5.529a2.76 2.76 0 0 0-2.28-1.623 2.76 2.76 0 0 0-2.55 1.17l-1.842 2.61-8.064-4.981 1.1-3.064a1 1 0 0 1 1.384-.558l.47.177a2.97 2.97 0 0 1 1.474 1.652l1.093 3.18a1 1 0 1 0 1.892-.651L12.814 9.25a4.96 4.96 0 0 0-2.46-2.759l-.47-.177a2.998 2.998 0 0 0-4.162 1.673l-.956 2.664-3.24-2.002A.999.999 0 1 0 .473 10.35l12.94 7.994-.904 1.281a2.75 2.75 0 0 0-.198 2.868 2.78 2.78 0 0 0 2.482 1.506h6.411c.956 0 1.835-.479 2.351-1.279a2.76 2.76 0 0 0 .194-2.641zm-1.876 1.558a.78.78 0 0 1-.669.362h-6.41a.77.77 0 0 1-.707-.426.75.75 0 0 1 .056-.795l3.902-5.529a.77.77 0 0 1 .725-.331.78.78 0 0 1 .648.458l2.51 5.53a.75.75 0 0 1-.056.73zM9 2.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M10 19v4a1 1 0 1 1-2 0v-4a1 1 0 1 1 2 0m-5.14-2.797-2.533 7.132a1 1 0 0 1-1.277.607 1 1 0 0 1-.607-1.277l2.532-7.132a.999.999 0 1 1 1.884.67"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-digging_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDigging;
